import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {
  COMMISSIONING_STEP,
  CommissioningStore,
  InstallationFeaturesStore,
  RemoteDeviceType,
  ZIGBEE_COORDINATOR_STATUS,
} from '@store';
import { zip } from 'rxjs';
import { take } from 'rxjs/operators';
import { ModalAction } from '../commissioning.model';
import { CommissioningService } from '../commissioning.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: './commissioning-pairing-result-modal.component.html',
  styleUrls: ['./commissioning-pairing-result-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommissioningPairingResultModalComponent implements OnInit {
  readonly RemoteDeviceType = RemoteDeviceType;
  isSuccess: boolean;
  title: string;
  instruction: string;
  deviceName: string;
  deviceType: RemoteDeviceType;
  errorStatus: ZIGBEE_COORDINATOR_STATUS;

  constructor(
    public commissioningStore: CommissioningStore,
    public installationFeaturesStore: InstallationFeaturesStore,
    private commissioningService: CommissioningService,
    private cdr: ChangeDetectorRef,
    private dialogRef: MatDialogRef<CommissioningPairingResultModalComponent>,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.dialogRef.updateSize('768px');
    this.dialogRef.addPanelClass('commissioning-modal');
    zip(
      this.commissioningService.selectedDevice$,
      this.commissioningStore.activeStep$,
      this.commissioningStore.pairingStatus$
    )
      .pipe(take(1))
      .subscribe(([device, step, pairingStatus]) => {
        this.deviceName = device.name;
        this.deviceType = device.type;

        this.isSuccess = step === COMMISSIONING_STEP.PAIRING_SUCCESS;

        if (!this.isSuccess) {
          this.errorStatus = pairingStatus.status;
        }

        this.cdr.markForCheck();
      });
  }

  getErrorMessage(): string {
    switch (this.errorStatus) {
      case ZIGBEE_COORDINATOR_STATUS.TYPE_MISMATCH:
        return this.translateService.instant('+SRC_COMMISSIONINGV2.PAIRING_ERROR_TYPE_MISMATCH');
      default:
        return this.translateService.instant('+SRC_COMMISSIONINGV2.PAIRING_ERROR_DESCRIPTION');
    }
  }

  navigateForward(): void {
    this.commissioningService.modalAction$.next(ModalAction.NextStep);
  }

  onTryAgain(): void {
    switch (this.errorStatus) {
      case ZIGBEE_COORDINATOR_STATUS.TYPE_MISMATCH:
        this.commissioningService.modalAction$.next(ModalAction.NavigateToStart);
        this.commissioningService.pairingStatusName$.next(ZIGBEE_COORDINATOR_STATUS.TYPE_MISMATCH);
        break;
      default:
        this.commissioningService.modalAction$.next(ModalAction.NavigateToReadyToConnect);
        this.commissioningService.pairingStatusName$.next(ZIGBEE_COORDINATOR_STATUS.INITIATING);
        break;
    }
  }

  closeDialog(): void {
    this.commissioningService.modalAction$.next(ModalAction.Close);
  }
}
